/**
 * TAA process flow of a case-type's BiPRO coordinate ({@code CwCaseTypeBipro.flow}). Drives the
 * configCheck panel's operationKey selector (spec §4.3): SIMPLE -> {getQuote,getOffer,getOrder,setOrder},
 * QUALIFIED -> + getOrderQualified/setOrderQualified, QUALIFIED_WITH_QUESTIONS -> + getOrderQuestions.
 *
 * Ordinals 3/4 are reserved (the struck v1 values QUOTE_ONLY/DIRECT_ORDER) — do not reuse.
 *
 * Mirrors the backend enum {@code com.mvs.backend.cw.enums.CwBiproFlowEnum}
 * (persisted via {@code @Enumerated(EnumType.ORDINAL)} — ordinals are stable and
 * MUST match the backend declaration order exactly): SIMPLE, QUALIFIED, QUALIFIED_WITH_QUESTIONS.
 */
export enum CwBiproFlowEnum {
    SIMPLE,
    QUALIFIED,
    QUALIFIED_WITH_QUESTIONS,
}
